export { ClientWorkspaceType as ReachWorkspaceType } from '~ng-common-lib/workspaces/workspace.type';
